import { getSavedState, saveState } from '@state/helpers'
import _ from 'lodash'

export const state = {
  selectedPersonnelOffice: getSavedState('personnel.selectedPersonnelOffice'),
  selectedProspect: getSavedState('personnel.selectedProspect'),
  lastProspectIdPrompt: getSavedState('personnel.lastProspectIdPrompt'),
  prospects: getSavedState('personnel.prospects'),
}

export const getters = {
  selectedPersonnelOffice(state) {
    return state.selectedPersonnelOffice
  },
  selectedProspect(state) {
    return state.selectedProspect
  },
  lastProspectIdPrompt(state) {
    return state.lastProspectIdPrompt
  },
  prospects(state) {
    if (state.prospects) {
      return _.orderBy(state.prospects, ['id'], ['desc'])
    }
    return state.prospects
  },
}

export const mutations = {
  SET_SELECTED_PERSONNEL_OFFICE(state, office) {
    state.selectedPersonnelOffice = office
    saveState('personnel.selectedPersonnelOffice', office)
  },
  SET_SELECTED_PROSPECT(state, prospect) {
    state.selectedProspect = prospect
    saveState('personnel.selectedProspect', prospect)
  },
  SET_LAST_PROSPECT_ID_PROMPT(state, newValue) {
    state.lastProspectIdPrompt = newValue
    saveState('personnel.lastProspectIdPrompt', newValue)
  },
  SET_PROSPECTS(state, prospects) {
    state.prospects = prospects
    saveState('personnel.prospects', prospects)
  },
  DELETE_PROSPECT(state, prospectId) {
    state.prospects = state.prospects.filter((prospect) => prospect.id !== prospectId)
    saveState('personnel.prospects', state.prospects)
  },
}
